'use client';

import { type ComponentProps, forwardRef } from 'react';

import { usePressAnimation } from '@shaojiang/hooks/usePressAnimation';

import { IconButton as StyledIconButton } from './styled/icon-button';

export type IconButtonProps = ComponentProps<typeof StyledIconButton>;

/** Park UI's icon button with Motion press feedback. */
export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>((props, ref) => {
  const pressRef = usePressAnimation(ref, !!props.disabled);
  return <StyledIconButton ref={pressRef} {...props} />;
});
IconButton.displayName = 'IconButton';
